// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"96866712","488":"84c8f65f"}[chunkId] + ".chunk.js";
};